import React, { Fragment } from 'react'
import { asField } from 'informed'
import { compose } from 'recompose'
import { useTranslation } from 'react-i18next'

import { Checkbox } from 'components/forms'
import { withFieldSubmit } from 'components/forms/Form'
import { useMutation, asyncClientQuery, updateQuery } from 'components/graphql'
import { DataTable } from 'components/DataTable'
import { listProductAdditionItems } from '../../../gql/query'
import { deleteProductAddition } from '../../../gql/mutation'
import { restaurant } from '../../../tableColumns'
import fetchedDataToForm from 'helpers/fetchedDataToForm'
import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'

const FieldAdditions = ({ fieldState: { value = [] }, fieldApi, smartSubmit, ...props }) => (
	<AdditionsList
		{...props}
		productAdditions={value}
		onValuesChange={({ id, isChecked }) => {
			const newVal = isChecked ? [...value, { productAddionId: id }] :
				value.map(item => Number(item.productAddionId) === Number(id) ? { id: item.id } : item)
			fieldApi.setValue(newVal)
			smartSubmit.submit(newVal)
		}}
		onDelItem={id => {
			const newVals = value.map(item => Number(item.productAddionId) === Number(id) ? { id: item.id } : item)
			fieldApi.setValue(newVals)
			smartSubmit.immidiateSubmit(newVals)
		}} />
)

const AdditionsList = ({ listAdditions = [], listAdditionsQuery, productAdditions = [], onValuesChange, onDelItem, onSelect, productId, client }) => {
	const [t] = useTranslation()
	const [delMutate] = useMutation(deleteProductAddition)

	const maxVariant = listAdditions.reduce((max, { variants = [] }) => {
		const localMax = variants.reduce((out, item, i) => item ? i + 1 : out, 0)
		return localMax > max ? localMax : max
	}, 5)
	const tableColumns = restaurant(t, maxVariant).map(col => {
		if(col.accessor === 'isActive') {
			return {
				...col,
				Cell: ({ original }) => (
					<Checkbox
						noForm
						checked={productAdditions.some(item => Number(item.productAddionId) === Number(original.id))}
						onChange={e => onValuesChange({ id: original.id, isChecked: e.target.checked })}
						stopPropagation />
				)
			}
		}
		return col
	})

	const checkingUse = async id => {
		const { data = {}, queryField } = await asyncClientQuery(client, listProductAdditionItems, {
			fetchPolicy: 'network-only',
			variables: { filter: { productAddionId: id } }
		})
		const prodNames = Array.isArray(data[queryField]) ?
			data[queryField].reduce((outArr, { product = {} }, i) => {
				if(Number(product.id) !== Number(productId)) {
					outArr.push(<li key={i}><b>{`${product.name}`}</b></li>)
				}
				return outArr
			}, [])
			: null
		return prodNames && prodNames.length ? { text: (
			<Fragment>
				{t('product_section.strings.delete_item_used')}:
				<ul style={{ textAlign: 'left', maxHeight: '5em', overflowY: 'scroll' }}>
					{prodNames}
				</ul>
				{t('common.strings.are_you_sure')}
			</Fragment>
		) }
			: {}
	}

	return(
		<DataTable
			data={listAdditions}
			columns={tableColumns}
			label={t('product_section.strings.kitchen_info')}
			selectRow
			onRowClick={(state, { original }) => onSelect(fetchedDataToForm(original))}
			onAddRecord={() => onSelect({})}
			mutateRow={{
				beforeRowMutate: checkingUse,
				onRowMutate: id => {
					const mutationName = getNameOfGqlQuery(deleteProductAddition)
					delMutate({
						variables: { id },
						update: updateQuery({ query: listAdditionsQuery }, (draft, { mutationResult, readQuery = [], queryField }) => {
							draft[queryField] = readQuery.filter((item = {}) => item.id.toString() !== mutationResult.id.toString())
						}),
						optimisticResponse: {
							cashAssist: {
								[mutationName]: {
									__typename: 'ProductAddition',
									id
								},
								__typename: 'CA_Mutation'
							}
						}
					})
					onDelItem(id)
					onSelect({ id: -1 })
				}
			}}
			sortable={false} />
	)
}

export default compose(asField, withFieldSubmit)(FieldAdditions)
